import { displayValueWithUnit, getDisplayInfo } from "utils/formatting";
import { Header, Paragraph } from "components/atoms/Typography";

function ImpactCard({ displayKey, value }: { displayKey: string; value: any }) {
    const { humanReadable, formatFunction, unit } = getDisplayInfo(displayKey, value);
    return (
        <div className="card card--small" key={displayKey}>
            <Paragraph>{humanReadable}</Paragraph>
            <Header size="medium">{displayValueWithUnit(value, unit, (v) => formatFunction(v))}</Header>
        </div>
    );
}

export default ImpactCard;
